import { __ } from '~/i18n'
import {get, head, isArray, isString, map, reduce, values} from "lodash";
import {Message} from "semantic-ui-react";
import React from "react";

export const getLabels = () => ({
  email: __('E-mail'),
  subscribe_to_newsletter: __('Subscribe to the newsletter'),
  first_name: __('First Name'),
  last_name: __('Last Name'),
  phone: __('Phone'),
  company_billing: __('Company billing'),
  company: __('Company'),
  address: {
    address: __('Address'),
    address_line_2: __('Address Line 2'),
    city: __('City'),
    postal_code: __('Postal Code'),
    state: __('State'),
    country: __('Country'),
  },
});

export const createFormProps = (values, setValue, submitErrors) => {
  return (key) => ({
    value: get(values, key),
    onChange: (e, {value}) => setValue(key, value),
    error: !!get(submitErrors, key),
    label: get(getLabels(), key),
    placeholder: get(getLabels(), key)
  })
};

export const createCheckFormProps = (values, setValue, submitErrors) => {
  return (key) => ({
    checked: get(values, key),
    onChange: (e, {checked}) => setValue(key, checked),
    error: !!get(submitErrors, key),
    label: get(getLabels(), key),
  });
};

export const Errors = ({id, errors}) => {
  if(errors) {
    const labels = getLabels();

    const createFieldErrors = (fieldErrors, field, path = '') => {
      let label = get(labels, `${path}${field}`);
      if(!isString(label)) {
        label = head(values(label)) || __('Field')
      }
      return map(fieldErrors, (error, index) => {
        return {
          label,
          error,
          key: `${path}${field}-${index}`
        };
      })
    };

    const createErrors = (errors, path = '') => {
      return reduce(errors, (sum, fieldErrors, field) => {
        if(isArray(fieldErrors)) {
          return [...sum, ...createFieldErrors(fieldErrors, `${path}${field}`)];
        }else {
          return [...sum, ...createErrors(fieldErrors, `${path}${field}.`)];
        }
      }, [])
    };

    const errorMessages = createErrors(errors);

    return (
      <Message error>
        <Message.List>
          {
            map(errorMessages, ({label, error, key}) => {
              return (
                <Message.Item key={ key }>
                  {label}: {error}
                </Message.Item>
              )
            })
          }
        </Message.List>
      </Message>
    );
  }

  return null;
}
